import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
const includes = ['6 Clinical Volumes — 300 pages', '4 Professional Bonuses — 160 pages', '460+ pages of evidence-based clinical content', 'Instant PDF access', 'Downloadable from any country worldwide', 'One-time payment, no subscription', 'Automatic local currency conversion', '14-Day money-back guarantee'];
export function ClosingBlock() {
  return <section id="cierre" className="w-full scroll-mt-20 bg-slate px-5 py-14 sm:py-24" data-id="element-41" data-mp="20sukprutx6cx">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-42" data-mp="1vz9p26gpkogw">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-43" data-mp="1hzqllqyue1ax">
          Your practice organized. Your consultations elevated. Your clinical system ready for today.
        </h2>
        <p className="mt-4 text-lg font-medium text-sage sm:text-xl" data-id="element-44" data-mp="3nrv2tqd7vvxf">
          NutriPro Complete System™
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-45" data-mp="3sm91q2r38l6u">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-46" data-mp="3dt5lpzt5afi8">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/20 text-sage" data-id="element-47" data-mp="3iveg90lo1pmg">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="afb9cx2do4z6" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-49" data-mp="fd4fxr7lf0zz">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center" data-id="element-50" data-mp="g3z4iqxwqga">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-51" data-mp="5enhk96brk3w">$350 USD</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-sage sm:text-7xl" data-id="element-52" data-mp="2l5jjauvnlgwy">
            $27 USD
          </span>
        </div>

        <motion.a href="#comprar" animate={{
        y: [0, -2, 0]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 14px 30px -10px rgba(184, 255, 76, 0.68)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.4,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-[#B8FF4C] px-6 py-4 text-base font-extrabold text-[#24411D] shadow-lg shadow-[#B8FF4C]/30 sm:text-lg" data-id="element-53" data-mp="2q3bcrtby5b39">
          GET MY COMPLETE SYSTEM NOW
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-54" data-mp="40dsnwc6f7z4">
          Instant Access · One-Time Payment · Automatic local currency conversion · 14-Day Money-Back Guarantee
        </p>
      </motion.div>
    </section>;
}